import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <main className="min-h-screen pt-28 pb-20" data-testid="blog-list-page">
      <div className="container-apex">
        <div className="max-w-3xl">
          <div className="overline">Journal</div>
          <h1 className="heading-display text-4xl sm:text-5xl lg:text-6xl mt-5">
            Field notes from Canadian <span className="text-[#16A34A]">back-offices.</span>
          </h1>
          <p className="mt-5 text-muted-foreground text-lg">
            Practical operations writing on outsourcing, paperwork systems, and getting your week back.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {loading && <div className="text-muted-foreground">Loading…</div>}
          {!loading && posts.length === 0 && <div className="text-muted-foreground">No posts yet.</div>}
          {posts.map((p, i) => (
            <motion.article
              key={p.id}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 3) * 0.08 }}
              className="card-apex overflow-hidden group cursor-pointer"
              data-testid={`blog-card-${p.slug}`}
              onClick={() => (window.location.href = `/blog/${p.slug}`)}
            >
              {p.cover_image && (
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
                </div>
              )}
              <div className="p-6">
                <div className="flex gap-2 flex-wrap">
                  {p.tags?.slice(0, 2).map((t) => (
                    <span key={t} className="text-[10px] tracking-widest uppercase font-bold text-[#16A34A]">{t}</span>
                  ))}
                </div>
                <h3 className="mt-3 font-display font-bold text-xl leading-tight group-hover:text-[#16A34A] transition">{p.title}</h3>
                <p className="mt-3 text-sm text-muted-foreground line-clamp-3">{p.excerpt}</p>
                <Link to={`/blog/${p.slug}`} className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#0B2545] dark:text-white hover:text-[#16A34A]">
                  Read article <ArrowRight size={14} />
                </Link>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </main>
  );
}
